
import React from 'react'
import { Card,  CardBody, Row, Col, Button, } from 'reactstrap'
// import ProgramTagList from './ProgramTagList'
import ProgramTag from './ProgramTag'
import { Link, } from 'react-router-dom'
import PropTypes from 'prop-types'
import mapActions from '../../../containers/SearchMapActionTypes'

const noop = () => {}

const ProgramSearchResult = ({
  activateProgramId = noop,
  address = null,
  baseHourlyWage = null,
  categories = [],
  isActive = false,
  mapDispatch = null,
  occupationName = '',
  pathname = '',
  programMainTitle = null,
  programName = '',
  programOccupationId = null,
  programOtherTitle = null,
  programType = null,
}) => {
  const onViewLocationsClick = React.useCallback((e) => {
    e.stopPropagation() 
    if (mapActions && mapDispatch) {
      mapDispatch(mapActions.toggleActiveProgram(programOccupationId, programType))
    }
  }, [ mapDispatch, programOccupationId, programType, ])

  const activateProgramResult = React.useCallback((e) => {
    e.preventDefault()
    if (!isActive) {
      activateProgramId(programOccupationId, programType)
    }
  }, [ activateProgramId, isActive, programOccupationId, programType, ])

  const resultTags = []
  if (address) {
    resultTags.push({ type: 'address', text: address, })
  }

  const buildProgramTags = () => {
    let tags = []
    const isLaunch = (categories && Array.isArray(categories) && categories.includes('launch'))
    const isExplore = (categories && Array.isArray(categories) && categories.includes('explore'))
    const isPrep = (categories && Array.isArray(categories) && categories.includes('prep'))
    if (programMainTitle){
      if (isLaunch) {
        tags.push(<ProgramTag key={'pgm-tag-main'} type={'launch'} text={programMainTitle} className={'float-right sr-title'}/>)
      } else if (isExplore) {
        tags.push(<ProgramTag key={'pgm-tag-main'} type={'explore'} text={programMainTitle} className={'float-right sr-title'} />)
      } else if (isPrep) {
        tags.push(<ProgramTag key={'pgm-tag-main'} type={'prep'} text={programMainTitle} className={'float-right sr-title'} />)
      } else {
        tags.push(<ProgramTag key={'pgm-tag-main'} text={programMainTitle} className={'float-right sr-title'}/>)
      }
    }
    if (programOtherTitle != null && programOtherTitle !== undefined && programOtherTitle.toLowerCase() !== 'other') {
      tags.push(<ProgramTag key={'pgm-tag-other'} text={programOtherTitle} className={'float-right sr-title'}/>)
    }
    return tags
  }

  return (
    <Card className={'result-card-body'}>
      <CardBody onClick={activateProgramResult} push={'true'}>
        <Link to={`${pathname}?type=${programType}&id=${programOccupationId}`}>
          <Row>
            <Col xs={12} sm={7}>
              <Row>
                <Col xs={12}>
                  <h2 className={'heading-4 float-left mb-1'}>{occupationName}</h2>
                </Col>
                <Col xs={12}>
                  <span className={'body-text-grey mb-4'}>{programName}</span>
                </Col>
              </Row>
            </Col>
            <Col xs={12} sm={5} className={'mt-3 mt-md-0'}>
              {
                buildProgramTags().map((t, idx) => {
                  return <Row key={`pgm-hd-tag-${idx}`}>
                    <Col xs={12}>
                      {t}
                    </Col>
                  </Row>
                })
              }
            </Col>
          </Row>
        </Link>
        <Row className={'mt-0'}>
          {/*<Col className={'pt-2'} style={{ bottom: '0%', }} xs={8} >
              <ProgramTagList tags={resultTags} programId={programOccupationId}/>
            </Col>*/}
          <Col xs={6}>
            {
              baseHourlyWage &&
              <Row key={'pgm-tag-wage'}>
                <Col xs={12}>
                  <ProgramTag
                    type={'finaid'}
                    text={`${baseHourlyWage.toFixed(2)} an hour`}
                    className={'float-left sr-wage mt-3'}
                  />
                </Col>
              </Row>
            }
          </Col>
          <Col xs={6}>
            <Button
              className={isActive ? 'btn-sm-grey active float-right' : 'btn-sm-grey float-right'}
              onClick={onViewLocationsClick}
            >
              {isActive ? 'Return to Search Results' : 'View this Program\'s Locations'}
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

ProgramSearchResult.propTypes = {
  activateProgramId   : PropTypes.func,
  address             : PropTypes.string,
  baseHourlyWage      : PropTypes.number,
  categories          : PropTypes.array,
  isActive            : PropTypes.bool,
  mapActions          : PropTypes.object,
  mapDispatch         : PropTypes.func,
  occupationName      : PropTypes.string,
  pathname            : PropTypes.string,
  programMainTitle    : PropTypes.string,
  programName         : PropTypes.string,
  programOccupationId : PropTypes.number,
  programOtherTitle   : PropTypes.string,
  programType         : PropTypes.string,
}

export default React.memo(ProgramSearchResult)